import { useLocation } from "react-router-dom";
import MenuLayout from "../../layouts/MenuLayout";
import Wellness from "../../components/pages/comman/nuvio-wellness";
import { fetchNuterraDetailsById } from "../../redux/features/coach/actions/coachAction";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/loader";

const NuvioWellness = () => {
  const data = useLocation()?.state?.data;

  const dispatch = useDispatch();
  const { isLoading2, workshopDetail } = useSelector((state) => state.coach.coach);
  const location = window?.location?.search?.split("=")[1];
  const [workShopData, setWorkShopData] = useState({
    data: {}
  });

  useEffect(() => {
    let data12 =
      workshopDetail && Object.keys(workshopDetail).length > 0
        ? workshopDetail
        : data;
    setWorkShopData(prev => ({
      ...prev,
      data: data12
    }));
  }, [workshopDetail]);

  useEffect(() => {
    window.scroll(0, 0);
    dispatch(fetchNuterraDetailsById({ payload: location }));
  }, []);

  if (isLoading2) {
    return <Loader />
  }
  return (
    <MenuLayout>
      {({ openSignUp }) => (
        <>
          <Wellness contentEditable={false} data={workShopData?.data} openSignUp={openSignUp} />
        </>
      )}
    </MenuLayout>
  );
};

export default NuvioWellness;
